import React from 'react';
import { SliceProvider, Box, Text } from '@lce/slice';
import { Dealmatic } from '@lce/gatsby-theme-bannermatic';

import * as Styled from '../../page-styles/index.style';
import Logo from '../Logo';

interface IDealsPage {
  locale: string;
}

const DealsPage: React.FC<IDealsPage> = ({ locale }) => (
  <SliceProvider>
    <Styled.Header>
      <Logo locale={ locale } />
    </Styled.Header>
    <Dealmatic baseUrl={ process.env.GATSBY_BASEURL || '' } locale={ locale } />
    <Box
      px={ [ 5, 8 ] }
      py={ [ 5 ] }
    >
      <Text
        fontSize="14px"
        margin="0 auto"
        textAlign="center"
        width={ [ 1, 2 / 3 ] }
      >
        {`©2003-${ new Date().getFullYear() } Little Caesar Enterprises, Inc. All rights reserved. The
        Little Caesars® Pizza name, logos and related marks are trademarks
        licensed to Little Caesar Enterprises, Inc.`}
      </Text>
    </Box>
  </SliceProvider>
);

export default DealsPage;
